import { onAuthStateChanged } from 'firebase/auth';
import { auth } from './firebase';

async function getAuthenticatedUser() {
  if (auth.currentUser) return auth.currentUser;
  return new Promise<typeof auth.currentUser>((resolve) => {
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      unsubscribe();
      resolve(user);
    });
  });
}

export async function authenticatedFetch(
  input: RequestInfo | URL,
  init: RequestInit = {},
) {
  const user = await getAuthenticatedUser();
  if (!user) throw new Error('Please sign in to view this receipt');
  const token = await user.getIdToken();
  const headers = new Headers(init.headers);
  headers.set('Authorization', `Bearer ${token}`);
  return fetch(input, { ...init, headers });
}
